<template>
	<div class="allImportDialog">
		<el-dialog title="导入样品订单" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
			<div class="content pl-4 pr-4">
				<div>
					<div class="label yx-color-text-primary font-h4-regular">1、下载导入模版</div>
					<div class="yx-color-primary mt-24">
						<i class="el-icon-download"></i>
						<a
							href="https://cdn.chaoyongbushou.com/partner/cyt/sample/%E6%A0%B7%E5%93%81%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
							class="ml-4 cursor-pointer yx-color-primary"
						>
							下载模版
						</a>
					</div>
				</div>

				<div class="label yx-color-text-primary font-h4-regular mt-24">2、填写后，上传该模版</div>
				<el-form class="mt-16" :model="form" :rules="rules" ref="ruleForm">
					<el-form-item prop="file">
						<el-upload
							ref="upload"
							accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
							action="no"
							:auto-upload="false"
							:http-request="upload"
							:on-remove="fileChange"
							:on-change="fileChange"
						>
							<el-button slot="trigger">{{ btnText }}</el-button>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer">
				<el-button type="primary" @click="submit">开始导入</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { batchImport } from '@/api/sampleOrder';

export default {
	name: 'importDialog',
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	components: {},
	data() {
		return {
			dialogVisible: false,
			form: {
				file: [],
			},
			rules: {
				file: { required: true, message: '请选择要导入的Excel文件', trigger: 'change' },
			},
			loading: false,
		};
	},
	computed: {
		btnText() {
			return this.form.file.length ? '重新添加' : '添加文件';
		},
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose(value) {
			this.form = {
				file: [],
			};
			this.loading = false;
			this.$refs.ruleForm.resetFields();
			this.$refs.upload.clearFiles();
			if (!value) return;
			this.dialogVisible = false;
		},
		fileChange(_, fileList) {
			if (fileList.length > 1) fileList.shift();
			this.form.file = fileList;
			this.$refs.ruleForm.validateField('file');
		},
		async upload(val) {
			const formData = new FormData();
			formData.append('file', val.file);
			this.loading = true;
			try {
				const { code } = await batchImport(formData);
				if (code === 0) {
					this.$message.success('导入成功！');
					this.$refs.upload.clearFiles();
					this.$emit('refresh');
					this.handleClose(1);
				}
			} finally {
				this.loading = false;
			}
		},
		submit() {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				this.$refs.upload.submit();
			});
		},
	},
};
</script>

<style lang="less" scoped></style>
